import styled from 'styled-components';
import HoverScrollText from './HoverScrollText';

export const SelectedProducts = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  height: 100%;
  width: 100%;
  min-width: 200px;
  border-radius: 8px;
  @media (max-width: 576px) {
    padding: 0;
    gap: 4px;
    min-width: 0;
    min-height: 120px;
    flex-direction: row;
    border-radius: 0;
    border-top: 1px solid #e9ecef;
    overflow-x: auto;
  }
`;

export const SelectedProduct = styled.div`
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: white;
  border: 1px solid #e9ecef;
  @media (max-width: 576px) {
    margin: 0;
    border: none;
  }
`;

export const SelectedProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  @media (max-width: 576px) {
    margin: 0;
    flex-direction: row;
  }
`;

export const ParentProductName = styled(HoverScrollText)`
  font-size: 14px;
  margin: 0;
`;

export const SelectedProductsText = styled.p`
  padding-bottom: 6px;
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  border-bottom: 1px solid #e9ecef;
  @media (max-width: 576px) {
    border: none;
    padding: 0;
    display: none;
  }
`;

export const EmptyStateWrapper = styled.div`
  height: 100%;
  margin: 0 auto;
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const NoProductsMessage = styled.p`
  text-align: center;
  color: #6c757d;
  font-size: 14px;
  margin: 0;
`;

export const Divider = styled.div`
  display: none;
  @media (max-width: 576px) {
    display: block;
    min-width: 1px;
    width: 1px;
    height: 100%;
    background-color: #e9ecef;
  }
`;
